import { styled, Typography } from "@material-ui/core";
import { FormattedMessage } from "react-intl";

const Banner = styled("aside")(({ theme }) => ({
  backgroundColor: theme.palette.grey[900],
  padding: theme.spacing(2),
}));

const Text = styled(Typography)(() => ({
  fontSize: "14px",
  color: "white",
}));

export const UnstableConnectionBanner = ({
  isInitiallyOffline,
}: {
  isInitiallyOffline: boolean;
}) => {
  return (
    <Banner data-testid="unstable-connection-banner">
      <Text style={{ fontSize: "14px" }}>
        {isInitiallyOffline ? (
          <FormattedMessage
            id="unstableConnectionBanner.initiallyOffline"
            defaultMessage={
              "<b>Unstable connection. Offline features unavailable.</b>"
            }
            values={{
              b: (chunks) => <b>{chunks}</b>,
            }}
          />
        ) : (
          <FormattedMessage
            id="unstableConnectionBanner.offlineDuringSession"
            defaultMessage={
              "<b>Your connection is unstable.</b> Registrations and consultations will work as normal. They will upload when your connection is stable. Other pages may take longer to load."
            }
            values={{
              b: (chunks) => <b>{chunks}</b>,
            }}
          />
        )}
      </Text>
    </Banner>
  );
};
